import React from 'react'
import PropTypes from 'prop-types'
import {Icon, Image, Segment, Step, Container, Dimmer, Loader, Button, Label} from 'semantic-ui-react'
import './ContentView.scss'
import {VIEW_STATE} from "../../../constants";

import Market from '../containers/MarketContainer'
import Account from '../containers/AccountContainer'

import {getLanguageScope} from '../../../helpers'

const _i18n = getLanguageScope('content');

export default class ContentView extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    const {view_state, loadingContent} = this.props;

    return (
      <Container className={'main-content'}>
        <Dimmer.Dimmable dimmed={loadingContent}>

          <Dimmer active={loadingContent} inverted>
            <Loader size='large'>{_i18n('loading')}</Loader>
          </Dimmer>

          {view_state === VIEW_STATE.MARKET ? <Market/> : null}
          {view_state === VIEW_STATE.ACCOUNT ? <Account/> : null}

        </Dimmer.Dimmable>
      </Container>
    )
  }
}

ContentView.propTypes = {
  changeStep: PropTypes.func,
  step: PropTypes.string,
  loadingContent: PropTypes.bool,
  appGuid: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/layouts/Content/components/ContentView.js